import { render, staticRenderFns } from "./S2aAppartement.vue?vue&type=template&id=7e6d8148&scoped=true&"
import script from "./S2aAppartement.vue?vue&type=script&lang=js&"
export * from "./S2aAppartement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e6d8148",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VApp,VBtn,VCarousel,VCarouselItem,VImg})
